/**
 * Detect mobile only. Excludes tablets.
 */
export const isMobile = {
  Android: function() {
      return /Android/i.test(navigator.userAgent);
  },
  iOS: function() {
      return /iPhone|iPod/i.test(navigator.userAgent);
  },
  any: function() {
      if(window.innerWidth < 480){
        return (isMobile.Android() || isMobile.iOS());
      }
  }
};


// WEBPACK FOOTER //
// ./app/scripts/util/is-mobile.js